export default function Footer() {
  return (
    <footer className="w-full border-t bg-gray-50 py-6 text-center mt-12 text-xs text-gray-500">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-2 px-3">
        <div>
          © {new Date().getFullYear()} A-Blind. All rights reserved.
        </div>
        <div className="flex gap-4">
          <a href="/about" className="hover:underline font-semibold">A-Blind 소개</a>
          <a href="/notice" className="hover:underline font-semibold">공지사항</a>
          <a href="/terms/serviceterms" className="hover:underline">이용약관</a>
          <a href="/terms/privacyterms" className="hover:underline">개인정보처리방침</a>
          <a href="mailto:support@a-blind.com" className="hover:underline">문의</a>
        </div>
      </div>
    </footer>
  );
}